export default __webpack_public_path__ + "static/media/wireframe.5a1bf3cf.jpeg";